import { useStrings } from "@1js/localization-components";
import {
  Button,
  DialogBody,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  Tooltip,
} from "@fluentui/react-components";
import { Dismiss32Regular } from "@fluentui/react-icons";
import * as React from "react";
import type { LinkedPrompt } from "../../services/prompt-client.web";
import {
  ConfirmationDialogClose,
  ManageAccessDialogDescription,
} from "./ManageSharedPrompts.strings";
import { SharedPromptsContent } from "./SharedPromptsContent";
type SharedPromptsDialogProps = {
  isLoading: boolean;
  onDeletePrompt: (prompt: LinkedPrompt) => void;
  prompts: LinkedPrompt[];
};

export const SharedPromptsDialog = ({
  isLoading,
  onDeletePrompt,
  prompts,
}: SharedPromptsDialogProps) => {
  const strings = useStrings({
    ManageAccessDialogDescription,
    ConfirmationDialogClose,
  });
  return (
    <DialogBody>
      <DialogTitle
        id="dialog-title-id"
        action={
          <Tooltip
            content={strings.ConfirmationDialogClose()}
            relationship="label"
          >
            <DialogTrigger action="close">
              <Button
                appearance="subtle"
                aria-label={strings.ConfirmationDialogClose()}
                icon={<Dismiss32Regular />}
              />
            </DialogTrigger>
          </Tooltip>
        }
      >
        {strings.ManageAccessDialogDescription()}
      </DialogTitle>
      <DialogContent>
        <SharedPromptsContent
          onDeletePrompt={onDeletePrompt}
          prompts={prompts}
          isLoading={isLoading}
        />
      </DialogContent>
    </DialogBody>
  );
};
